import React, { Component } from "react";
import PropTypes from "prop-types";
import AppButton from "../component/AppButton";
import AppHelper from "../model/AppHelper";
import { Howl } from "howler";
import "./FlashcardAudioPlayer.css";

export class FlashcardAudioPlayer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      playbackLoopHandler: "",
      audioPlayer: null,
      playDuration: 0
    };
    this.playbackLoopHandler = null;
  }
  static propTypes = {
    pageItem: PropTypes.object.isRequired,
    isPageActive: PropTypes.bool,
    onLoadComplete: PropTypes.func
  }

  static defaultProps = {
    onLoadComplete: () => {}
  }

  componentDidMount() {
    const { pageItem, isPageActive, onLoadComplete } = this.props;
    console.log(isPageActive);
    var audioPlayer = new Howl({
      src: [AppHelper.formatUrl(pageItem.getAudioUrl())],
      autoplay: false,
      onload: () => { onLoadComplete(pageItem, audioPlayer) },
      onerror: () => { onLoadComplete(pageItem, audioPlayer) }
    });
    this.bindAudioEvents(audioPlayer);
    this.setState({ audioPlayer });
  }

  componentWillUnmount() {
    this.unbindAudioEvents(this.state.audioPlayer);
  }

  bindAudioEvents(audioPlayer) {
    audioPlayer.on("play", this.onAudioPlayerPlay.bind(this));
    audioPlayer.on("pause", this.onAudioPlayerPause.bind(this));
    audioPlayer.on("stop", this.onAudioPlayerStop.bind(this));
    audioPlayer.on("end", this.onAudioPlayerStop.bind(this));
  }

  unbindAudioEvents(audioPlayer) {
    clearInterval(this.playbackLoopHandler);
    if (!audioPlayer) {
      return;
    }
    audioPlayer.off("play", this.onAudioPlayerPlay.bind(this));
    audioPlayer.off("pause", this.onAudioPlayerPause.bind(this));
    audioPlayer.off("stop", this.onAudioPlayerStop.bind(this));
    audioPlayer.off("end", this.onAudioPlayerStop.bind(this));
  }

  handlePlay = () => {
    if (!this.props.isPageActive && this.state.audioPlayer.playing()) {
      this.state.audioPlayer.pause();
      console.log("3");

      clearInterval(this.playbackLoopHandler);

      return;
    }
  };

  getPlayer = () => {
    return this.state.audioPlayer;
  }

  onAudioPlayerPlay() {
    this.handlePlay();
    this.playbackLoopHandler = setInterval(() => {
      this.handlePlay();
      this.setState({
        playDuration: this.state.audioPlayer.seek()
      });
    }, 300);
    this.setState({});
  }

  onAudioPlayerPause() {
    const me = this;
    clearInterval(me.playbackLoopHandler);
    this.setState({});
  }
  onAudioPlayerEnd() {
    const me = this;
    clearInterval(me.playbackLoopHandler);
  }
  onAudioPlayerStop() {
    const me = this;
    clearInterval(me.playbackLoopHandler);
    me.setState({
      playDuration: me.state.audioPlayer.duration()
    });
  }

  render() {
    const { audioPlayer } = this.state;
    const { pageItem } = this.props;
    if (!audioPlayer) {
      return null;
    }
    const { playDuration } = this.state;
    const progress = playDuration / (pageItem.getAudioDuration() || 1);
    const radius = 20;
    const cirucmference = 2 * Math.PI * radius;
    const strokeWidth = 4;
    const offsetCircumference = (1 - progress) * cirucmference;
    const isPlaying = audioPlayer.playing();
    const isMuted = audioPlayer.mute();

    return (
      <div className="audio-playback-container">
        <div className="audio-progress-container">
          <svg width={2 * radius} height={2 * radius} viewBox="0 0 44 44">
            <circle
              cx={radius + strokeWidth / 2}
              cy={radius + strokeWidth / 2}
              r={radius}
              fill="none"
              stroke="#00bf4f"
              strokeWidth={strokeWidth}
              strokeDasharray={cirucmference}
              strokeLinecap="round"
              strokeDashoffset={offsetCircumference}
            />
          </svg>
          <AppButton buttonIconCls="icon-audio" />
        </div>
        <div className="audio-controls">
          <AppButton
            buttonIconCls={isPlaying ? "icon-pause_s" : "icon-play_s"}
            buttonCls="button-audio-playpause"
            clickHandler={this.toggleAudioPlay.bind(this)}
          />
          <AppButton
            buttonIconCls="icon-audio"
            buttonCls={`button-audio-volume ${isMuted ? "mute" : ""}`}
            clickHandler={this.toggleAudioMute.bind(this)}
          />
        </div>
      </div>
    );
  }

  componentWillReceiveProps(nextProps) {
    const { audioPlayer } = this.state;
    if (
      this.props.isPageActive != nextProps.isPageActive &&
      nextProps.isPageActive &&
      audioPlayer &&
      !audioPlayer.playing()
    ) {
      audioPlayer.play();
    } else if (
      !nextProps.isPageActive &&
      audioPlayer &&
      audioPlayer.playing()
    ) {
      audioPlayer.pause();
      console.log("1");
    }
  }

  toggleAudioMute() {
    const { audioPlayer } = this.state;
    if (!!audioPlayer) {
      audioPlayer.mute(!audioPlayer.mute());
      this.setState({});
    }
  }

  toggleAudioPlay() {
    const { isPageActive } = this.props;
    const { audioPlayer } = this.state;
    if (!!audioPlayer) {
      audioPlayer.playing() && isPageActive
        ? audioPlayer.pause()
        : audioPlayer.play();
      console.log("2");
    }
  }
}

export default FlashcardAudioPlayer;
